import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import equal from 'fast-deep-equal';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import { noop } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { GlobalFieldLightRepeatableInstanceScreen } from 'screens/FieldComponents/GlobalFieldLightRepeatableInstanceScreen';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import {
  selectAssetFieldRepeatableInstance,
  selectAssetOrganisationId,
} from 'store/assets/selectors';
import { selectOrganisationFieldGroup } from 'store/organisations/selectors';
import { AppContextEnum } from 'types/types';

type ModalProps = ModalScreenProps<ModalScreens.AstLightRepeatableInstance>;

export const LightRepeatableInstanceModal: React.FC<ModalProps> = ({
  route,
}) => {
  const dispatch = useDispatch();

  const { assetId, groupId, instanceId } = route.params;

  const organisationId = useSelector((state) =>
    selectAssetOrganisationId(state, assetId),
  );

  const group = useSelector((state) =>
    selectOrganisationFieldGroup(state, organisationId, groupId),
  );

  const instance = useSelector(
    (state) => selectAssetFieldRepeatableInstance(state, assetId, instanceId),
    equal,
  );

  const handleGoBack = React.useCallback(() => {
    dispatch(NAVIGATE_MODAL_BACK());
  }, [dispatch]);

  useEsc(handleGoBack);

  const isBeingOpenInvalid = instanceId && !instance;
  React.useEffect(() => {
    if (isBeingOpenInvalid) {
      handleGoBack();
    }
  }, [handleGoBack, isBeingOpenInvalid]);

  if (!group || !instance) {
    return null;
  }

  return (
    <GlobalFieldLightRepeatableInstanceScreen
      context={{
        context: AppContextEnum.localAsset,
        assetId,
      }}
      editableFieldIds={[]}
      hiddenFieldIds={[]}
      requiredFieldIds={[]}
      id={instanceId}
      isNew={false}
      results={instance.results}
      group={group}
      fields={group.fields}
      onPressCancelButton={handleGoBack}
      onChange={noop}
      otherInstances={[]}
      showInvalid={false}
    />
  );
};
